import { render, staticRenderFns } from "./VArrowButton.vue?vue&type=template&id=489e1788&scoped=true&lang=pug&"
import script from "./VArrowButton.vue?vue&type=script&lang=js&"
export * from "./VArrowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e1788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489e1788')) {
      api.createRecord('489e1788', component.options)
    } else {
      api.reload('489e1788', component.options)
    }
    module.hot.accept("./VArrowButton.vue?vue&type=template&id=489e1788&scoped=true&lang=pug&", function () {
      api.rerender('489e1788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/buttons/VArrowButton.vue"
export default component.exports